var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60003 5.6C9.38786 5.6 9.18438 5.51571 9.03435 5.36569C8.88432 5.21566 8.80003 5.01217 8.80003 4.8C8.80003 4.58783 8.88432 4.38434 9.03435 4.23431C9.18438 4.08429 9.38786 4 9.60003 4H13.6C13.8122 4 14.0157 4.08429 14.1657 4.23431C14.3157 4.38434 14.4 4.58783 14.4 4.8V8.8C14.4 9.01217 14.3157 9.21566 14.1657 9.36569C14.0157 9.51571 13.8122 9.6 13.6 9.6C13.3879 9.6 13.1844 9.51571 13.0343 9.36569C12.8843 9.21566 12.8 9.01217 12.8 8.8V6.7312L9.36563 10.1656C9.21561 10.3156 9.01216 10.3998 8.80003 10.3998C8.5879 10.3998 8.38446 10.3156 8.23443 10.1656L6.40003 8.3312L2.96563 11.7656C2.81475 11.9113 2.61267 11.992 2.40291 11.9901C2.19315 11.9883 1.9925 11.9042 1.84418 11.7559C1.69585 11.6075 1.61172 11.4069 1.60989 11.1971C1.60807 10.9874 1.68871 10.7853 1.83443 10.6344L5.83443 6.6344C5.98446 6.48442 6.1879 6.40017 6.40003 6.40017C6.61216 6.40017 6.81561 6.48442 6.96563 6.6344L8.80003 8.4688L11.6688 5.6H9.60003Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/TrendingUp.83bb5b7444b9341172c8bf050bbb2bc7.svg";
export { ForwardRef as ReactComponent };